import { OccupationCategory, UserProfile } from '@cpd-app/core-module/models';
import { OccupationCardCategoryType } from '@cpd-app/generated';

export class OccupationCategoryBusinessRules {
  static applyBusinessRules(
    category: OccupationCategory,
    userProfile: UserProfile,
    isCareerGoalSet: boolean
  ): OccupationCategory {
    let message = '';
    let isLocked = false;

    switch (category.occupationCardCategoryType) {
      case OccupationCardCategoryType.AiFastestPath:
        {
          isLocked = !userProfile?.isSkillsSurveyComplete;
          message =
            'We do not have enough information about your skills to match to careers.';
        }
        break;

      case OccupationCardCategoryType.Interests:
        {
          isLocked = !userProfile?.isInterestsSurveyComplete;
        }
        break;

      case OccupationCardCategoryType.Lifestyle:
      case OccupationCardCategoryType.HotLocations:
        {
          isLocked = !userProfile?.isLifestyleSurveyComplete;
        }
        break;

      case OccupationCardCategoryType.Values:
        {
          isLocked = !userProfile?.isWorkValuesSurveyComplete;
        }
        break;

      case OccupationCardCategoryType.Competencies:
        {
          if (!userProfile?.isSkillsSurveyComplete) {
            isLocked = true;
          }
          message =
            'We do not have enough information about your skills to match to careers.';
        }
        break;

      case OccupationCardCategoryType.CareerGoals:
        {
          isLocked = !userProfile?.userHasPreGoal && !isCareerGoalSet;
          message = 'Set a career goal to match with occupations';
        }
        break;

      default:
        break;
    }

    return {
      ...category,
      isLocked,
      message
    };
  }
}
